import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { ActivatedRoute } from '@angular/router';
import { IPlayer } from '../../models/player';
import { MatSort, MatTableDataSource } from '@angular/material';
import { TimeService } from '../../services/time/time.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  dataSource;
  players: IPlayer[] = [];
  owner;
  displayedColumns = [];
  constructor(
    private db: AngularFirestore,
    private route: ActivatedRoute,
    public timeService: TimeService
  ) {}

  ngOnInit() {
    this.db
      .collection('players', ref =>
        ref.where('highestBid.owner', '==', this.route.snapshot.params.id)
      )
      .valueChanges()
      .subscribe(players => {
        const playersCast = players as IPlayer[];
        this.players = playersCast.sort(function(a, b) {
          return a.highestBid.time - b.highestBid.time;
        });
        this.dataSource = new MatTableDataSource(players as IPlayer[]);
        this.dataSource.sort = this.sort;
      });
    this.db
      .collection('owners', ref =>
        ref.where('ownerId', '==', this.route.snapshot.params.id)
      )
      .valueChanges()
      .subscribe(owners => {
        this.owner = owners.length ? owners[0] : null;
      });
    if (window.innerWidth <= 800 && window.innerHeight <= 800) {
      this.displayedColumns = ['name', 'position', 'hbt', 'hba', 'hby', 'hbta'];
    } else {
      this.displayedColumns = [
        'firstName',
        'lastName',
        'position',
        'byeWeek',
        'team',
        'hbt',
        'hba',
        'hby',
        'hbta'
      ];
    }
  }

  playersWon() {
    let sum = 0;
    this.players.forEach(player => {
      if (
        this.timeService.getTimeLeftInt(
          player.highestBid.time,
          this.timeService.currentTimeInt
        ) < 0
      ) {
        sum++;
      }
    });
    return sum;
  }

  activeBids() {
    let sum = 0;
    this.players.forEach(player => {
      if (
        this.timeService.getTimeLeftInt(
          player.highestBid.time,
          this.timeService.currentTimeInt
        ) > 0
      ) {
        sum++;
      }
    });
    return sum;
  }

  maxBid() {
    let sum = 0;
    this.players.forEach(player => {
      sum += player.highestBid.amount;
    });
    return (
      245 -
      (this.owner ? this.owner.deadSalary : 0) -
      (16 - this.players.length) -
      sum
    );
  }
}
